import React, { Component, Fragment } from 'react';
import { Formik, Form, Field } from 'formik'; 
import { Button, Grid, Divider, Message, List, Label, Image, Loader, Dimmer, Checkbox } from 'semantic-ui-react'

import DropzoneComponent from 'react-dropzone-component';
import _ from 'underscore';
import { Link } from 'react-router-dom';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import '../../../../../node_modules/react-dropzone-component/styles/filepicker.css';
import '../../../../../node_modules/dropzone/dist/min/dropzone.min.css';

import FormsInputsText from '../../inputs/text/forms_inputs_text';
import FormsInputDate from '../../inputs/date';
import FormsInputDropdown from '../../inputs/dropdown';
import FormsInputDropdownSearch from '../../inputs/dropdownsearch';
// import FormsInputsRadioGroup from '../../inputs/radio';
import FormsInputsRadioGroupDynamic from '../../inputs/radiodynamic';
import FormsInputsDropdownAddition from '../../inputs/dropdownaddition';
import FormsInputsTime from '../../inputs/time';

import OutpatientValidationSchema from './validation';
import { djsConfig } from '../../../../template/DropZoneTemplate';
import CommonUtility from '../../../../utils/CommonUtility'

const yesNoOptions = [
    { text: 'Yes', value: 'Y' },
    { text: 'No', value: 'N'}
];

const prePostOthersOptions = [
    { text: 'Pre / Post Hospitalisation', value: 'Y' },
    { text: 'Others', value: 'N'}
];

const paybackOptions = [
    { text: "Employee's Bank Account", value: 'Bank'},
    { text: 'Cheque', value: 'Cheque' },
    { text: "PayNow via NRIC", value: 'PayNow via NRIC'},
    { text: "Reimbursement by Company", value: 'Payroll'},
    { text: "Reimbursement by Insurer", value: 'Insurer'},
];

const paybackOptionBank = [
    { text: "Employee's Bank Account", value: 'Bank'}
];

var componentConfig = {
    iconFiletypes: ['.jpeg', '.jpg', '.png', '.pdf'],
    showFiletypeIcon: true,
    postUrl: 'no-url'
};
// var djsConfig = {
//     autoProcessQueue: false,
//     addRemoveLinks: true,
// }
// var eventHandlers = { addedfile: (file) => console.log(file) }

// const prepareDynamicDropDownSelection = (list, useValueAsText = false) => {
//     return _.map(list, (item) => {
//         return { text: (useValueAsText === false) ? item.n : item.c , value: item.c };
//     })
// }
const prepareDynamicDropDownSelectionCompany = (list, useValueAsText = false) => {
    const selectedList = list.filter( company => company.memberType.toUpperCase() == "E");

    return _.map(selectedList, (item) => {
        return { text: (useValueAsText === false) ? item.companyName : item.companyId , value: item.companyId };
    })
};

const prepareDynamicDropDownSelectionClaimant = (list, selectedCompany) => {
    const selectedList = list.filter( company => company.companyId === selectedCompany.companyId);
    if (selectedList[0]) 
    {
        return selectedList[0].records.map( item => {
            return { text: item.name, value: item.nric }
        })
    } else {
            return []
    }
};

const prepareDynamicDropDownSelectionHospital = (list, useValueAsText = false, useTextAsValue = false) => {
    var sorted = _.sortBy(list, 'n');
    return _.map(sorted, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
}

const prepareDynamicDropDownSelectionHospitalWithAddition = (selectedValue, list, useValueAsText = false, useTextAsValue = false) => {
    var object = _.find(list, (item) => { return item.n === selectedValue })
    var _list = list
    if (object === undefined) {
        _list.push({'n': selectedValue})
    }
    var sorted = _.sortBy(_list, 'n');
    return _.map(sorted, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
}

const prepareDynamicDropDownSelectionWithAddition = (selectedValue, list, useValueAsText = false, useTextAsValue = false) => {
    var _list = list

    var object = _.find(list, (item) => {
        return item.n.toUpperCase() === selectedValue.toUpperCase()
    })

    if (object === undefined) {
        _list.push({'n': selectedValue})
    }

    return _.map(_list, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
}

const prepareDynamicDropDownSelection = (list, useValueAsText = false, useTextAsValue = false) => {
    return _.map(list, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
}

const prepareBankOrBranchListOptions = (list) => {
    return _.map(list, (item, index) => {
        return { text: item.n, value: item.c, key: index};
    });
}

const prepareRadioSelection = (list) => {
    return _.map(list, (data) => {
        return { label: data.name, value: data.nric };
    })
};

const prepareBenefitGroupSelection = (list) => {
    return _.map(list, (item) => {
        return { text: item.g, value: item.g };
    })
}

const prepareBenefitGroupItemSelection = (list) => {
    return _.map(list, (item) => {
        return { 
            text: item.n, 
            value: item.id, 
            sd: item.sd, 
            ptc: item.ptc,
            id: item.id
        }; 
    })
}

class FormsUpdateClaimOutpatient extends Component {
    constructor(props) {
        super(props);
        this.refFormik = React.createRef();
    }

    state = {
        files: [],
        error: false,
        errorMessage: null,
        success: false,
        currentAttachment: this.props.currentClaimData.attachment,
        isLoading: false,
        selectedDiagnosesText: '',
        visitDateErrorMessage: null,
        showDiagnosis:null,
        successMessage:null,
        selectedBenefitId: this.props.currentClaimData.benefitId,
        payNowTerm: false  
    }

    componentDidMount(){
        this._reloadPage();
        if (this.props.currentClaimData.paymentMethod == "PayNow via NRIC") this.setState({ payNowTerm: true });
    }

    componentDidUpdate(prevProps){
        const { filteredByCompany, filteredByVisitDate, filteredByClaimantId } = prevProps
        if(filteredByCompany !== this.props.filteredByCompany || filteredByVisitDate !== this.props.filteredByVisitDate || filteredByClaimantId !== this.props.filteredByClaimantId){
            this._reloadPage()
        }
    }


    _reloadPage(){
        let filteredByCompany = this.props.claimFilterOptions.filterByCompany ? this.props.claimFilterOptions.filterByCompany : this.props.user.companies[0].companyId;
        let selectedCompany = this.props.user.companies.filter( company => company.companyId == filteredByCompany);
        let selectedClaimantId = selectedCompany[0].records.filter( claimant => claimant.nric.toLowerCase() == this.props.currentClaimData.nric.toLowerCase());
        let selectedVisitDate = this.props.filteredByVisitDate ? moment(this.props.filteredByVisitDate).format('DD/MM/YYYY') : this.props.currentClaimData.visitDate;

        this.props.getClaimOptionsRequest()
        this.props.getEclaimOptionsPageAction(this.props.user.accessToken, selectedVisitDate, this.props.filteredByCompany, selectedClaimantId[0].uuid, (result, error) => {
            if(error){
                this.setState({
                    visitDateErrorMessage: error.errorMessage
                })
            } else {
                this.setState({
                    visitDateErrorMessage: null
                })
                if (result){
                    if (this.props.filteredByVisitDate){
                    let { bl } = result.data.claimoptions.outpatientClaimConfig;

                    let benefitTypeOptions = prepareBenefitGroupSelection(bl);

                    this.refFormik.current.setFieldValue('benefitGroupItem', prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === benefitTypeOptions[0].value)).ol)[0].value);
                    this.refFormik.current.setFieldValue('benefitGroup', benefitTypeOptions[0].value);
                    this.refFormik.current.setFieldValue('showDiagnosis', bl[0].ol[0].sd);  

                }
                }
               
            }
        })
    }

    updateFileTest(file, is_invoice_receipt = false) {
        if (is_invoice_receipt) {
            file.upload.is_invoice_receipt = true;
        }

        this.setState({files: [...this.state.files, file]});
    }

    removeFile(file) { 
        this.setState({
            files: this.state.files.filter(f => f !== file),
            error:false,
            errorMessage:''});
    }

    renderClaimSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Claim Updated Successfully!</Message.Header>
                    <p>
                        <Link to={`/app/claimrecords/out/${this.props.currentClaimData.transactionNo}`}>
                            Click here to view the claim now!
                        </Link>
                    </p>
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the claim</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    removeSelectedAttachmentId = (filename) => {
        const newCurrentAttachment = _.filter(this.state.currentAttachment, (attachment) => attachment.filename !== filename);
        this.setState({currentAttachment: newCurrentAttachment});
    }
    renderAttachmentList(attachments, status) {
        return _.map(attachments, (attachment, index) => {
            // console.log(index, attachment);
            let claimAttached = null
            const { filename, viewUrl } = attachment;
            if(status==="PROCESSING"){ 
                claimAttached = this.props.claimAttachment.filter( item => item.objectId === filename )
                console.log("check claim attachment", claimAttached)
            }

            return (
                <List.Item key={filename}>
                    <List.Content floated='right'>
                        <Button
                            type="button"
                            onClick={() => this.removeSelectedAttachmentId(filename)}
                        >
                            Delete
                        </Button>
                    </List.Content>
                    {(status!=="PROCESSING")&&
                        <Image avatar src={viewUrl} />
                    }
                    {(status==="PROCESSING")&&
                        <Image avatar src={claimAttached[0].attachmentLink} />
                    }
                    <List.Content>
                        <Label color='red' horizontal>
                            IMG
                        </Label>
                        { 
                            attachment.remarks
                            ? `Uploaded Document (${attachment.remarks})` 
                            : 'Uploaded Document (Other)'
                        }
                    </List.Content>
                </List.Item>
                
            );
        });
    }
    checkAttachmentFile() {
        if (this.state.files.find( (file) => file.size >= 5242880)) {
            return (
                <Message negative>
                    <p>
                        { 'The attachment has exceeded the maximum limit of 5MB. Kindly resize and upload the document again.' }
                    </p>
                </Message>
            );
        }
    }

    checkVisitDate() {
        if (this.state.visitDateErrorMessage) {
            return (
                <Message negative>
                    <p>
                        {this.state.visitDateErrorMessage}
                    </p>
                </Message>
            );
        }
    }
    

    handlebenefitGroupItem(value){ 
        const { bl } = this.props.claimOptions;   
        bl[0].ol.forEach(option=>{  
            if (option.id === value){  
                console.log('option', option)
                this.setState({
                    showDiagnosis : option.sd
                  }
                )
            }
        })
    }

    // Checking other document set mandatory or not
    // return true if optional, false if mandatory
    _checkOtherDocumentOptional() {
        const benefitMenuList = prepareBenefitGroupSelection(this.props.claimOptions.bl);

        const selectedIndex = benefitMenuList.findIndex(
            e => e.id == this.state.selectedBenefitId
        );

        if (selectedIndex == -1) return true;

        const selectedItem = benefitMenuList[selectedIndex];

        // Checking if supportingVisitCode configuration
        // already exist if no aborting proccess
        if (!this.props) return true;
        if (!this.props.configBenefit) return true;
        if (!this.props.configBenefit.supportingVisitCode) return true;
        if (!selectedItem) return true;
        if (!selectedItem.ptc) return true;
        
        const supportingVisitTypes = this.props
            .configBenefit
            .supportingVisitCode;

        const visitTypeCode = selectedItem.ptc;

        
        if (supportingVisitTypes.includes(visitTypeCode)) {
            return false;
        }

        return true;
    }

    handleAgreeChange = () => {
        this.setState({ payNowTerm: !this.state.payNowTerm })
    }

    render() {
        const { dl, bl, cl } = this.props.claimOptions;
        const { hl, bbl, paymentConfig } = this.props.inpatientClaimOptions;
        const bankList = this.props.inpatientClaimOptions.bl;
        const { bankDetail, costCenterName } = this.props.user;
        const benefitTypeOptions = prepareBenefitGroupSelection(bl);
        const typeOfVisits = prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === benefitTypeOptions[0].value)).ol)
        // console.log(this.props.currentClaimData);
        const selectedCompanyId = this.props.claimFilterOptions.filterByCompany ? this.props.claimFilterOptions.filterByCompany : this.props.user.companies[0].companyId;


        const {
            transactionNo,
            benefitGroup,
            benefitId,
            nric,
            prePostHospitalisation,
            providerName,
            visitDate,
            receiptNo,
            diagnosisText,
            diagnosisName,
            diagnosisCode,
            diagnosisTextFromMember,
            originalAmount,
            // remarks,
            empSubRemarks,
            status,
            accidentRelated,
            workRelated,
            accidentDateTime,
            accidentDetails,
            placeOfAccident,
            accidentClaimableFromCompany,
            claimingFromOtherInsurer,
            claimingFromOtherInsurerName,
            claimReferenceNo,
            // payee,
            claimStatus,
            paymentMethod,
            bankName,
            bankNo,
            branchNo,
            accountNo,
            includeGST,
            gstAmount
        } = this.props.currentClaimData;

        let isShowDiagnosis
        let benefitsObj = _.find(bl, (benefitType) => benefitType.g === benefitGroup)
        if (benefitsObj){
            let benefit = benefitsObj.ol.find(benefit=>benefit.id == benefitId)
            isShowDiagnosis = benefit.sd
        } else {
            if (diagnosisCode){
                isShowDiagnosis = true
            } else {
                isShowDiagnosis = false
            } 
        } 
        // console.log('currentClaimData', this.props.currentClaimData)
        const isFieldsDisabled = (status === 'Submitted' || status === 'PROCESSING') ? false : true;
        // prepare value diagnosisText
        var _diagnosisText = ''
        console.log("check diagnosisText", diagnosisTextFromMember)
        if (diagnosisTextFromMember && diagnosisTextFromMember.length > 0){
            _diagnosisText = diagnosisTextFromMember
        }
        else if (diagnosisCode){
            var diagnosis = dl.find(diagnosis => {
                return diagnosis.c === diagnosisCode
            })
            _diagnosisText = diagnosis.n
        }
        // console.log('_diagnosisText', _diagnosisText);

        // app launch config
        const appLaunchConfig = this.props.appLaunchConfig
        const configBenefit = this.props.configBenefit

        // default payment options

        let paymentOpions = [];
        const config = configBenefit.featuresConfig;
        const giroOnly = config.giroOnly;
        const cheque = config.chequeOnly;
        const payNow =  config.payNowOnly;
        const payrollOnly =  config.payrollOnly;
        const allowEclaimPaymentByInsurer =  config.allowEclaimPaymentByInsurer;


        //hide Cheque option for following conditions
        if (appLaunchConfig.appLaunchConfig && appLaunchConfig.appLaunchConfig.moh_company_code && (configBenefit.benefit.companyCode.toLowerCase() === appLaunchConfig.appLaunchConfig.moh_company_code.toLowerCase()
            ||
            configBenefit.benefit.companyCode.toLowerCase() === appLaunchConfig.appLaunchConfig.smu_company_local_code.toLowerCase()
            ||
            (configBenefit.benefit.companyCode.toLowerCase() === appLaunchConfig.appLaunchConfig.smu_company_international_code.toLowerCase()
              &&
              !appLaunchConfig.appLaunchConfig.smu_program_code.includes(costCenterName.trim().toLowerCase())))
            )
            {
                if (giroOnly) paymentOpions.push(paybackOptions[0])
                if (payNow) paymentOpions.push(paybackOptions[2])
                if (payrollOnly) paymentOpions.push(paybackOptions[3])
                if (allowEclaimPaymentByInsurer) paymentOpions.push(paybackOptions[4])
            } else {
                if (giroOnly) paymentOpions.push(paybackOptions[0])
                if (cheque) paymentOpions.push(paybackOptions[1])
                if (payNow) paymentOpions.push(paybackOptions[2])
                if (payrollOnly) paymentOpions.push(paybackOptions[3])
                if (allowEclaimPaymentByInsurer) paymentOpions.push(paybackOptions[4])
            }
        // default payment options
        var _paybackOptions = paymentOpions
        // selected is not in option, set initial in first option
        var isInOption = _paybackOptions.find(item => item.value === paymentMethod)
        var _paymentMethod = isInOption ? paymentMethod : _paybackOptions[0].value
        var initialVal = ""
        // status not submit, take _paymentMethod even if not in option
        if (status !== "Submitted") {
            var initialVal = isInOption ? "" : paymentMethod
            var _paymentMethod = paymentMethod
        } 

        return (
            <div>
                {
                    this.state.success
                    &&
                    <Message positive>
                    {(status !== 'PROCESSING')&&
                        <p>
                           {this.state.successMessage}
                        </p>
                    }
                    {(status === 'PROCESSING')&&
                        <p>
                            {this.state.successMessage}
                        </p>
                    }
                        
                        <p>
                            Please tap on <span><Link to={`/app/askjoey?type=outclaim&id=${this.props.currentClaimData.transactionNo}`}>Ask Joey</Link></span> if you have any questions on the claim.
                        </p>
                        <p>
                            <Link to="/app/claimrecords">
                                <Button>
                                    Back to eClaims
                                </Button>
                            </Link>
                        </p>
                    </Message>
                }
                {
                <Dimmer active={this.props.isLoaded} inverted top >
                    <Loader />
                </Dimmer>

                }
                {
                    !this.state.success
                    &&
                    <Formik
                        ref ={this.refFormik}
                        initialValues={{
                            companyId : selectedCompanyId,
                            benefitGroup: benefitGroup || benefitTypeOptions[0].value,
                            benefitGroupItem: benefitId || prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === benefitTypeOptions[0].value)).ol)[0].value,
                            claimantId: nric.toLowerCase(),
                            prePostHospitalisation: prePostHospitalisation,
                            providerName: providerName,
                            visitDate: moment(visitDate, 'D/M/YYYY') || moment(),
                            receiptNo: receiptNo,
                            diagnosisCode: diagnosisCode || '',
                            diagnosisTextFromMember: diagnosisTextFromMember || '',
                            diagnosisText: _diagnosisText || '',
                            currency: originalAmount.currency,
                            amount: originalAmount.amount,
                            empSubRemarks: empSubRemarks || '',
                            uploadAttachments: '',
                            // benefitId: '',

                            accidentRelated: accidentRelated || 'N',
                            workRelated: workRelated || 'N',
                            accidentDate: (accidentDateTime) ? moment(accidentDateTime, 'D/MM/YYYY') : moment(),
                            accidentTime: (accidentDateTime) ? moment(accidentDateTime, 'D/MM/YYYY HH:mm') : moment(),
                            accidentDetails: accidentDetails || '',
                            placeOfAccident: placeOfAccident || '',
                            accidentClaimableFromCompany: accidentClaimableFromCompany || 'N',
                            claimingFromOtherInsurer: claimingFromOtherInsurer || 'N',
                            claimingFromOtherInsurerName: claimingFromOtherInsurerName || '',
                            claimReferenceNo: claimReferenceNo || '',

                            paymentMethod: _paymentMethod,
                            bankName: (bankName) ? bankName : (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.bankName : '',
                            bankNo: (bankNo) ? bankNo : (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.bankNo : '',
                            branchNo: (branchNo) ? branchNo : (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.branchNo : '',
                            accountNo: (accountNo) ? accountNo : (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.accountNo : '',
                            showDiagnosis: isShowDiagnosis,
                            includeGST: includeGST ? 'Y' : 'N',
                            gstAmount: gstAmount,
                            nric: CommonUtility.maskString(nric, {unmaskedPattern:"4"})
                        }}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validationSchema={OutpatientValidationSchema}
                        validate={(values) => {
                            // Additional Validation (if any)
                            let error = {};
                            let totalNumOfFiles = 0
                            totalNumOfFiles += this.state.currentAttachment.length;
                            totalNumOfFiles += this.state.files.length;

                            const isOtherDocumentOptional = this._checkOtherDocumentOptional();

                            // Checking common document
                            const noFoundCurrentDocument = this.state
                                .currentAttachment.findIndex(e => !e.remarks) == -1 
                                ? true : false;

                            const noFoundNewDocument = this.state.files.findIndex(e => 
                                e.upload && !e.upload.is_invoice_receipt) == -1 
                                ? true : false;

                            if (!isOtherDocumentOptional && noFoundCurrentDocument 
                                && noFoundNewDocument) {
                                
                                error.uploadAttachments = 'This field is required.';
                            }

                            // Checking invoice receipt document
                            const noFoundCurrentInvoice = this.state
                                .currentAttachment.findIndex(e => 
                                e.remarks && e.remarks.toUpperCase() == 'INVOICE/RECEIPT') == -1 
                                ? true : false;

                            const noFoundNewInvoice = this.state.files.findIndex(e => 
                                e.upload && e.upload.is_invoice_receipt) == -1 
                                ? true : false;

                            if (noFoundCurrentInvoice && noFoundNewInvoice) {
                                
                                error.uploadAttachmentsInv = 'This field is required.';
                            }
                            
                            if (this.state.files.find( (file) => file.size >= 5242880 )) {
                                error.maxFileSize = 'The attachment has exceeded the maximum limit of 5MB. Kindly resize and upload the document again.';
                            }

                            if (this.state.visitDateErrorMessage) {
                                error.visitDate = this.state.visitDateErrorMessage
                            }

                            if (values['includeGST'] == 'Y') {
                                if (!values['gstAmount']){
                                    error.gstAmount = 'GST Amount is required.'
                                }
                                if (values['gstAmount'] <= 0){
                                    error.gstAmount = 'GST Amount must be more than zero'
                                }
                                if (values['amount'] && values['gstAmount'] && Number(values['gstAmount']) >= Number(values['amount'])) {
                                    error.gstAmount = 'GST amount must not higher and equal than amount'
                                }
                            }
                            if (values.paymentMethod === "PayNow via NRIC" && !this.state.payNowTerm){
                                error.payNowTermUncheck = "Missing information. Please review and check."
                            }
                            return error;
                        }}
                        onSubmit={(values, actions) => {
                            // console.log(values, actions);
                            // Prepare Data To Submit
                            // 0 - Create a Copy of current "values" object
                            let data = Object.assign({}, _.omit(values,["showDiagnosis"]));
                            // 1 - Convert Visit Date to (DD/MM/YYYY) format
                            data.visitDate = moment(data.visitDate).format('DD/MM/YYYY');
                            // 1 - Combine and omit fields "accidentDate", "accidentTime" into "accidentDateTime" (DD/MM/YYYY HH:mm)
                            data.accidentDateTime = `${moment(data.accidentDate).format('DD/MM/YYYY')} ${moment(data.accidentTime).format('HH:mm')}`
                            data = _.omit(data, ["accidentDate", "accidentTime"]);
                            // 2 - Copy field "benefitGroupItem" as "benefitId"
                            data.benefitId = data.benefitGroupItem;
                            data.benefitName = _.find(typeOfVisits, (item) => { return item.value === values.benefitGroupItem }).text
                            // 2 - Omit field "benefitGroup", "benefitGroupItem"
                            data = _.omit(data, ['benefitGroup', 'benefitGroupItem', "bankName", "bankNo", "branchNo", "accountNo"]);
                            // 3 - If paymentMethod = 'Cheque', omit fields "bankNo", "branchNo", "accountNo"
                            // if (data.paymentMethod === 'Cheque') { data = _.omit(data, ["bankNo", "branchNo", "accountNo"]); }
                            // 4 - If accidentRelated = 'N', omit fields "accidentDateTime", "workRelated", "accidentDetails"
                            if (data.accidentRelated === 'N') { data = _.omit(data, ["accidentDateTime", "workRelated", "accidentDetails", "placeOfAccident"]); }
                            // 5 - If claimingFromOtherInsurer = 'N', omit fields "claimingFromOtherInsurerName"
                            if (data.claimingFromOtherInsurer === 'N') { data = _.omit(data, ["claimingFromOtherInsurerName"]); }

                            // diagnosis
                            var diagnosis = dl.find(diagnosis => {
                                return diagnosis.n === data.diagnosisText
                            })
                            if (typeof diagnosis === "undefined") {
                                data.diagnosisTextFromMember = data.diagnosisText
                            }
                            else {
                                data.diagnosisCode = diagnosis.c
                                data.diagnosisName = data.diagnosisText
                            }

                            // Submit Data to Action Handler
                            let selectedNric = this.props.claims.filter( item => item.tx === transactionNo )
                            if(status && status === "PROCESSING"){
                                selectedNric = this.props.claims.filter( item => item.id === this.props.claimTransactionNo )
                            }

                            if (values.includeGST === 'N') { data.gstAmount = '0' }
                            console.log("check formData", data)

                            if (this.state.files && this.state.files.length) {
                                data.attachmentDetails = [];
                                
                                data.attachmentDetails = this.state.files.map(e => {
                                    return e.upload.is_invoice_receipt ? 'INV/RCP' : 'DOC'
                                })
                            }

                            if (status !== 'PROCESSING'){
                                this.props.updateOutpatientClaim({
                                    data,
                                    attachments: this.state.files,
                                    oldAttachments: this.state.currentAttachment,
                                    accessToken: this.props.user.accessToken,
                                    // nric: this.props.user.nric,
                                    nric: selectedNric[0].ic,
                                    transactionNo
                                }, (result, error) => {
                                    if (error) {
                                        console.log('done-failed');
                                        actions.setSubmitting(false);
                                        this.setState({error: true, success: false, errorMessage: error.message});
                                    }
                                    if (result) {
                                        console.log('done-success');
                                        this.setState({error: false, success: true, errorMessage: null,successMessage:result.message});
                                    }
                                });
                            }else{
                                console.log("from updateUnsubmittedOutpatientClaim  ")
                                this.props.updateUnsubmittedOutpatientClaim({
                                    data,
                                    attachments: this.state.files,
                                    oldAttachments: this.state.currentAttachment,
                                    accessToken: this.props.user.accessToken,
                                    // nric: this.props.user.nric,
                                    nric: selectedNric[0].ic,
                                    claimId: this.props.claimTransactionNo
                                }, (result, error) => {
                                    if (error) {
                                        console.log('done-failed');
                                        actions.setSubmitting(false);
                                        this.setState({error: true, success: false, errorMessage: error.message});
                                    }
                                    if (result) {
                                        console.log('done-success', result);
                                        this.setState({error: false, success: true, errorMessage: null});
                                    }
                                });
                            }
                            
                        }}
                        render={({
                            values,
                            errors,
                            status,
                            touched,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                        }) => (
                            <Form style={{paddingBottom: 20}}>
                                <Grid container columns={2}>
                                    {/* ##YIN - commented */}
                                    {/*
                                        <Grid.Column width={16}>
                                            <Divider horizontal>
                                                Benefit Type Information
                                            </Divider>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Field
                                                name="benefitGroup"
                                                options={benefitTypeOptions}
                                                label="Type of Benefit"
                                                secondaryLabel="Select the type of benefit"
                                                component={FormsInputDropdown}
                                                disabled={isFieldsDisabled}
                                            />
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Field
                                                name="benefitGroupItem"
                                                options={prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === values.benefitGroup)).ol)}
                                                label="Benefit Option"
                                                secondaryLabel="Select the benefit option"
                                                component={FormsInputDropdown}
                                                disabled={isFieldsDisabled}
                                            />
                                        </Grid.Column>
                                    */}
                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            Claim Information
                                        </Divider>
                                    </Grid.Column>
                                    {/* <Grid.Column width={16}>
                                        <Field
                                            name="claimantId"
                                            label="Claimant"
                                            component={FormsInputsRadioGroupDynamic}
                                            secondaryLabel=""
                                            choices={prepareRadioSelection(this.props.user.records)}
                                            disabled={true}
                                        />
                                    </Grid.Column> */}
                                    {this.props.user.companies.length > 1 &&
                                    <Grid.Column>
                                        <Field
                                            name="companyId"
                                            label="Select Company"
                                            secondaryLabel=""
                                            options={prepareDynamicDropDownSelectionCompany(this.props.user.companies)}
                                            component={FormsInputDropdown}
                                            disabled={true}
                                        />
                                    </Grid.Column>}
                                    <Grid.Column>
                                        <Field
                                            name="claimantId"
                                            label="Select Claimant"
                                            secondaryLabel=""
                                            options={prepareDynamicDropDownSelectionClaimant(this.props.user.companies, _.pick(values,['companyId']))}
                                            component={FormsInputDropdown}
                                            disabled={true}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="visitDate"
                                            component={FormsInputDate}
                                            label="Visit Date"
                                            secondaryLabel="Select the date of visit"
                                            maxDate={moment()}
                                            disabled={isFieldsDisabled}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="benefitGroupItem" 
                                            options={bl && _.find(bl, (benefitType) => benefitType.g === values.benefitGroup) ? prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === values.benefitGroup)).ol) : prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g)).ol)}
                                            // options={ prepareBenefitGroupItemSelection(
                                            //     (_.map(bl, (benefitType) => benefitType.ol[0]))
                                            // ) }
                                            label="Type of Visit"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                            onChange={(value)=>this.handlebenefitGroupItem(value)}
                                        />
                                        {/*##YIN // TODO:  - to call API once visit date is selected */}
                                        {/*
                                            <Field
                                                name="prePostHospitalisation"
                                                options={prePostOthersOptions}
                                                label="Type of Visit"
                                                secondaryLabel="Is your visit a pre or post hospitalisation"
                                                component={FormsInputDropdown}
                                                disabled={isFieldsDisabled}
                                            />
                                        */}
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="providerName"
                                            label="Clinic/Provider Name"
                                            options={prepareDynamicDropDownSelectionHospitalWithAddition(values.providerName, hl, false, true)}
                                            component={FormsInputsDropdownAddition}
                                            secondaryLabel=""
                                            disabled={isFieldsDisabled}
                                        />
                                        {/*#YIN // TODO: - to revisit and read the provider label from TW's API */}
                                        {/*
                                            <Field
                                                name="providerName"
                                                label={(_.find((_.find(bl, (benefitType) => benefitType.g === values.benefitGroup).ol), (item) => item.id === values.benefitGroupItem)).pt}
                                                component={FormsInputsText}
                                                secondaryLabel="Input the name of provider that you have visited"
                                            />
                                        */}
                                    </Grid.Column>

                                    <Grid.Column>
                                        <Field
                                            name="receiptNo"
                                            label="Receipt/Invoice Number"
                                            component={FormsInputsText}
                                            secondaryLabel=""
                                            disabled={isFieldsDisabled}
                                        />
                                    </Grid.Column>
                                    {values.showDiagnosis && <Grid.Column width={16}>
                                    <Field
                                        name="diagnosisText"
                                        options={prepareDynamicDropDownSelectionWithAddition(values.diagnosisTextFromMember, dl, false, true)}
                                        label="Diagnosis / Medical Condition"
                                        secondaryLabel=""
                                        component={FormsInputsDropdownAddition}
                                        disabled={isFieldsDisabled}
                                        onChange={(data)=>{
                                            this.setState({
                                                selectedDiagnosesText: data
                                            })
                                        }}
                                    />
                                </Grid.Column>}
                                    
                                    <Grid.Column>
                                        <Field
                                            name="currency"
                                            options={prepareDynamicDropDownSelection(cl, true)}
                                            label="Currency"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                            disabled={isFieldsDisabled}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="amount"
                                            label="Amount"
                                            component={FormsInputsText}
                                            secondaryLabel=""
                                            disabled={isFieldsDisabled}
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Field
                                            name="includeGST"
                                            options={yesNoOptions}
                                            label="Does the amount above include GST?"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    {
                                        (values.includeGST === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="gstAmount"
                                                    label="Please insert the amount of GST"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    <Grid.Column width={16}>
                                        <Field
                                            name="empSubRemarks"
                                            label="Remarks (Optional)"
                                            component={FormsInputsText}
                                            secondaryLabel=""
                                            disabled={isFieldsDisabled}
                                        />
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            Injury Information
                                        </Divider>
                                    </Grid.Column>

                                    <Grid.Column>
                                        <Field
                                            name="accidentRelated"
                                            options={yesNoOptions}
                                            label="Is this claim for treatment of injury as a result of an accident?"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column>
                                                <Field
                                                    name="accidentDate"
                                                    component={FormsInputDate}
                                                    label="Date of Accident"
                                                    secondaryLabel=""
                                                    maxDate={values.visitDate}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column>
                                                <Field
                                                    name="accidentTime"
                                                    label="Time of Accident"
                                                    component={FormsInputsTime}
                                                    secondaryLabel=""
                                                    minTime={ moment().startOf('day') }
                                                    maxTime={ moment() }
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="placeOfAccident"
                                                    label="Place of Accident"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column>
                                                <Field
                                                    name="workRelated"
                                                    options={yesNoOptions}
                                                    label="Is it work related?"
                                                    secondaryLabel=""
                                                    component={FormsInputDropdown}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentDetails"
                                                    label="Give details of how the injury was caused by the accident. (Please enclose a copy of the police report, if any)"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y")
                                        &&
                                        (values.workRelated === "Y")
                                        &&
                                        (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentClaimableFromCompany"
                                                    options={yesNoOptions}
                                                    label="Are these medical expenses claimable under your company's work injury compensation act policy?"
                                                    secondaryLabel=""
                                                    component={FormsInputDropdown}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    <Grid.Column width={16}>
                                        <Field
                                            name="claimingFromOtherInsurer"
                                            options={yesNoOptions}
                                            label="Have you claimed or do you intend to claim from any insurer, other employer or any other parties for reimbursement of your medical bills? If yes, please state the party that you are claiming from and submit a copy of the settlement letter or payment voucher from the other party."
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    {
                                        (values.claimingFromOtherInsurer === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="claimingFromOtherInsurerName"
                                                    label="Name of the party that you are claiming from"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }

                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            Reimbursement Information
                                        </Divider>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Field
                                            name="paymentMethod"
                                            options={_paybackOptions}
                                            label="Payment to be made by"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                            disabled={!paymentConfig.updateBankInfo}
                                            initialVal={initialVal}
                                        />
                                    </Grid.Column>

                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <Grid.Column width={16}>
                                                <Message>
                                                    <p>
                                                        The following bank account in your Profile must be your bank account. If you provide us with an inaccurate bank account number, we will not be liable for any losses incurred by you.
                                                    </p>
                                                </Message>
                                            </Grid.Column>
                                        )
                                    }

                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <Grid.Column>
                                                <Field
                                                    name="bankName"
                                                    label="Bank Name"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={true}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <Grid.Column>
                                                <Field
                                                    name="branchNo"
                                                    label="Bank Branch"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={true}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <Grid.Column>
                                                <Field
                                                    name="accountNo"
                                                    label="Bank Account Number"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={true}
                                                />
                                            </Grid.Column>
                                        )
                                    }

                                    {
                                        (values.paymentMethod === "PayNow via NRIC") &&
                                        (
                                            <Grid.Column>
                                                <Field
                                                    name="nric"
                                                    label="NRIC"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={true}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                
                                    {
                                    (values.paymentMethod === "PayNow via NRIC") &&
                                        (
                                            <Grid.Column width={16}>
                                                 <Message>
                                                    <p>
                                                    In order for reimbursement transactions to be successful, kindly acknowledge that you have registered for PayNow via NRIC. Otherwise, please select another payment mode to avoid unintended delays in reimbursement.
                                                    </p>
                                                </Message>
                                                <Checkbox
                                                    label='I confirmed that I have registered for PayNow via NRIC.'
                                                    onChange={this.handleAgreeChange}
                                                    checked={this.state.payNowTerm}
                                                />
                                                {
                                                (errors['payNowTermUncheck']) &&
                                                    (
                                                        <Message negative>
                                                            {errors['payNowTermUncheck']}
                                                        </Message>
                                                    )
                                                }
                                        </Grid.Column>
                                        )
                                    }

                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            All Required Documents, Documentary Proofs, Medical Reports
                                        </Divider>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Message warning>
                                            <p>
                                                Please prepare scanned copy of your supporting documents for upload before proceeding with this new eSubmission.
                                            </p>
                                            <p>
                                                Scan files must meet the following criteria:
                                            </p>
                                            <ul>
                                                <li>
                                                    Acceptable file formats are pdf, jpg, jpeg and png
                                                </li>
                                                <li>
                                                    Maximum allowable size for each attachment is up to 5MB
                                                </li>
                                            </ul>
                                            <p>
                                                Please note that you must keep the original tax invoice(s)/receipt(s) for at least 6 months from claim submission date and must be made readily available upon Insurer's request. Please ensure your email address and handphone number updated in the e-claim portal are correct.
                                            </p>
                                            <p>
                                                When we pay an eligible claim, precedence shall be given in the following order:
                                            </p>
                                            <ul>
                                                <li>
                                                    Employee if they have settled the eligible medical bills by cash
                                                </li>
                                                <li>
                                                    Medisave account as indicated in the tax invoices or bills
                                                </li>
                                                <li>
                                                    Patient's Medisave-Approved Integrated Shield Plan or CPF Medishield Life (if applicable) in accordance with the CPF Act.
                                                </li>
                                            </ul>
                                        </Message>
                                    </Grid.Column>

                                    <Grid.Column width={8}>
                                        {/* TAX INVOICE RECEIPT DOCUMENT */}
                                        <Fragment>
                                            You may upload more than {this.props.configBenefit.featuresConfig.maximumFileUpload} tax invoice/receipt:
                                            
                                            <DropzoneComponent
                                                config={componentConfig}
                                                eventHandlers={
                                                    {
                                                        maxfilesexceeded: (file) => {
                                                            const maxUpload = this.props.configBenefit && this.props.configBenefit.featuresConfig.maximumFileUpload 
                                                            ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                            : 5
                                                            
                                                            alert(`You can only upload up to ${ maxUpload } files!`);
                                                            this.removeFile(file);
                                                            file.previewElement.remove(); // Remove the extra file from the UI
                                                        },
                                                        addedfile: (file) => {
                                                            // console.log(file);
                                                            if (file.type.includes('jpeg')||
                                                                file.type.includes('jpg')||
                                                                file.type.includes('png')||
                                                                file.type.includes('pdf')||
                                                                file.type.includes('heif')||
                                                                file.type.includes('heic')){
                                                                    this.updateFileTest(file, true);
                                                                } else {
                                                                    this.setState({error:true,errorMessage:'Only image file (jpeg, jpg, png) and PDF file are allowed.'})
                                                                }
                                                        },
                                                        removedfile: (file) => {
                                                            this.removeFile(file);
                                                        }
                                                    }
                                                }
                                                djsConfig={{
                                                    ...djsConfig,
                                                    maxFiles: this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    : 5 
                                                }}
                                            />
                                            {this.checkAttachmentFile()}
                                            {
                                                (errors['uploadAttachments']) &&
                                                (
                                                    <Message negative>
                                                        {errors['uploadAttachments']}
                                                    </Message>
                                                )
                                            }
                                        </Fragment>

                                        <div style={{ height: 24 }}></div>

                                        {/* COMMON DOCUMENTS */}
                                        <Fragment>
                                            You may upload more than {this.props.configBenefit.featuresConfig.maximumFileUpload} other supporting documents:
                                            <DropzoneComponent
                                                config={componentConfig}
                                                eventHandlers={
                                                    {
                                                        maxfilesexceeded: (file) => {
                                                            const maxUpload = this.props.configBenefit && this.props.configBenefit.featuresConfig.maximumFileUpload 
                                                            ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                            : 5
                                                            
                                                            alert(`You can only upload up to ${ maxUpload } files!`);
                                                            this.removeFile(file);
                                                            file.previewElement.remove(); // Remove the extra file from the UI
                                                        },
                                                        addedfile: (file) => {
                                                            // console.log(file);
                                                            
                                                            if (file.type.includes('jpeg')||
                                                                file.type.includes('jpg')||
                                                                file.type.includes('png')||
                                                                file.type.includes('pdf')||
                                                                file.type.includes('heif')||
                                                                file.type.includes('heic')){
                                                                    this.updateFileTest(file);
                                                                } else {
                                                                    this.setState({error:true,errorMessage:'Only image file (jpeg, jpg, png) and PDF file are allowed.'})
                                                                }
                                                        },
                                                        removedfile: (file) => {
                                                            this.removeFile(file);
                                                        }
                                                    }
                                                }
                                                djsConfig={{
                                                    ...djsConfig,
                                                    maxFiles: this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    : 5 
                                                }}
                                            />
                                            {this.checkAttachmentFile()}
                                            {
                                                (errors['uploadAttachments']) &&
                                                (
                                                    <Message negative>
                                                        {errors['uploadAttachments']}
                                                    </Message>
                                                )
                                            }
                                        </Fragment>
                                    </Grid.Column>
                                    
                                    <Grid.Column width={8}>
                                        <h4>
                                            Current Attachments ({this.state.currentAttachment.length})
                                        </h4>
                                        <List divided>
                                            {this.renderAttachmentList(this.state.currentAttachment, claimStatus)}
                                        </List>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        {this.renderClaimSubmissionResult()}
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Button
                                            loading={isSubmitting}
                                            type="submit"
                                            primary
                                            disabled={isSubmitting}
                                            fluid
                                            size="big"
                                        >
                                            Update Claim Information
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        )}
                    />
                }
            </div>
        );
    }
}

export default FormsUpdateClaimOutpatient;
